import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import BannerBG from './../../assets/images/empower/banner.jpg'
import Slider from "react-slick";
import caseData from './caseData'
import quote from './../../assets/images/homepage/case/quote.png'
import MoreRight from './../../assets/images/more-right-golden.png'
import rectangleGolden from './../../assets/images/rectangle-golden.png'
import ArrowLeft from './../../assets/images/arrow-left.png'
import ArrowRight from './../../assets/images/arrow-right.png'
import { injectIntl } from 'react-intl';
import { Link } from "react-router-dom";
import CountUp from 'react-countup';
import clsx from 'clsx'
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
        color: "#fff",
        height: "calc( 100vh + 280px)",
        maxHeight: "1300px",
        backgroundImage: `url(${BannerBG})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        padding: "140px 0px 0px 0px",
        overflow: "hidden",
        minHeight: "1200px",
        "& .title": {
            width: "fit-content",
            margin: "0px auto 30px auto",
            textAlign: "center",
            lineHeight: "50px"
        },
        "& .amount-block": {
            width: "100%",
            maxWidth: "500px",
            margin: "0px auto",
            display: "flex"
        },
        "& .amount": {
            flex: "1",
            textAlign: "center"
        },
        "& .amount-number": {
            fontSize: "60px",
            color: "#dab873"
        },
        "& .amount-title": {
            fontSize: "16px"
        },
        "& .case-block": {
            padding: "0px 24px",
            maxWidth: "1140px",
            margin: "60px auto 0px auto",
            "& li button:before": {
                content: "''",
                backgroundSize: "cover",
                width: "10px",
                height: "10px",
                backgroundImage: `url(${rectangleGolden})`
            },
            "& .slick-active button:before": {
                backgroundImage: `url(${rectangleGolden})`
            }
            ,
            [theme.breakpoints.down('sm')]: {
                margin: "100px auto 0px auto",
            }
        },
        "& .case": {
            padding: "0px",
            transformOrigin: "bottom",
            transition: "0.3s",
        },
        "& .slick-slide": {
            transition: "0.3s",
            opacity: "0.6",
            "& .case": {
                transform: "scale(0.7)",
                [theme.breakpoints.down('sm')]: {
                    transform: "scale(0.8) ",
                },
                [theme.breakpoints.down('xs')]: {
                    transform: "scale(0.9)",
                },
            }
        },
        "& .slick-center": {
            opacity: "1",
            "& .case": {
                transform: "scale(1) !important",
                [theme.breakpoints.down('xs')]: {
                    transform: "scale(1)  !important",
                },
            },
            "& .type": {
                opacity: "1"
            }
        },
        "& .slick-list": {
            overflow: "visible",
        },
        "& .slick-dots": {
            bottom: "-60px",
            [theme.breakpoints.down('xs')]: {
                textAlign: "center",
                marginLeft: "-24px"
            }
        },
        "& .slick-track": {
            display: "flex",
            alignItems: "flex-end"
        },
    },
    caseRoot: {
        position: "relative",
        "& .card": {
            position: "relative",
            background: "#fff",
            padding: "48px",
            [theme.breakpoints.down('sm')]: {
                padding: "30px 24px"
            },
            "@media(max-width:325px)": {
                padding: "20px"
            },
            "&:hover .more-details": {
                cursor: "pointer",
                opacity: "1",
                "& .more-details-icon": {
                    animationDuration: "0.6s",
                    animationName: "$mask",
                    animationFillMode: "forwards"
                }
            }
        },
        "& .quote": {
            width: "32px",
            height: "24px",
            [theme.breakpoints.down('sm')]: {
                width: "20px",
                height: "17px"
            }
        },
        "& .thoughts": {
            lineHeight: "33px",
            height: "160px",
            margin: "30px 0px 20px 0px",
            color: "#3b3b3b",
            overflow: "hidden",
            [theme.breakpoints.down('sm')]: {
                lineHeight: "30px",
                margin: "20px 0px",
                height: "180px",
            },
            [theme.breakpoints.down('xs')]: {
                margin: "20px 0px",
                height: "200px",
                "&.en": {
                    fontSize: "14px",
                    lineHeight: "28px",
                }
            }
        },
        "& .card-bottom": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        },
        "& .people": {
            display: "flex",
            alignItems: "center"
        },
        "& .avatar": {
            backgroundSize: "cover",
            width: "72px",
            height: "72px",
            marginRight: "18px",
            [theme.breakpoints.down('sm')]: {
                marginRight: "12px",
                width: "48px",
                height: "48px",
            },
            "@media(max-width:325px)": {
                width: "32px",
                height: "32px",
            }
        },
        "& .job": {
            color: "#001733"
        },
        "& .name": {
            color: "#292929"
        },
        "& .logo": {
            objectFit: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
            width: "80px",
            height: "80px",
            [theme.breakpoints.down('sm')]: {
                width: "48px",
                height: "48px",
            },
            "@media(max-width:325px)": {
                width: "32px",
                height: "32px",
            }
        },
        "& .more-details": {
            width: "86px",
            transition: "0.15s",
            opacity: "0",
            position: "absolute",
            top: "46px",
            right: "46px",
            color: "rgba(0,23,51,0.3)",
            [theme.breakpoints.down('sm')]: {
                top: "25px",
                right: "25px",
            }
        },
        "& .more-details-icon": {
            marginLeft: "7px",
            width: "15px",
            height: "10px",
            display: "inline-block"
        }
    },

}))

const Banner = (props: any) => {
    const classes = useStyles()
    const { intl } = props
    const settings = {
        arrows: false,
        dots: true,
        centerMode: true,
        centerPadding: "220px",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    centerPadding: "200px",
                }
            },
            {
                breakpoint: 900,
                settings: {
                    centerPadding: "150px",
                }
            },
            {
                breakpoint: 800,
                settings: {
                    centerPadding: "100px",
                }
            },
            {
                breakpoint: 700,
                settings: {
                    centerPadding: "50px",
                }
            },
            {
                breakpoint: 500,
                settings: {
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 400,
                settings: {
                    centerPadding: "20px",
                }
            },
        ]
    }
    return (
        <div className={classes.root}>
            <Typography className="title" variant="h2" dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: "empowerList.banner.title" }) }} />
            <div className="amount-block">
                <div className="amount">
                    <div className="amount-number"><CountUp end={6} duration={2} />+</div>  {/* useEasing */}
                    <div className="amount-title">{intl.formatMessage({ id: "empowerList.banner.count1" })}</div>
                </div>
                <div className="amount">
                    <div className="amount-number"><CountUp end={10} duration={2} />+</div>
                    <div className="amount-title">{intl.formatMessage({ id: "empowerList.banner.count2" })}</div>
                </div>
                <div className="amount">
                    <div className="amount-number"><CountUp end={5} duration={2} />+</div>
                    <div className="amount-title">{intl.formatMessage({ id: "empowerList.banner.count3" })}</div>
                </div>
            </div>
            <Slider {...settings} className="case-block">
                {caseData.map((item: any, index: number) =>
                    <CaseCard key={index} data={item} intl={intl} />
                )}
            </Slider>
        </div>
    )
}

const CaseCard = (props: any) => {
    const classes = useStyles()
    const { data, intl } = props
    const global = useSelector((state: any) => state.global);
    const isEnglish = global.locale == 'en_us'
    return (
        <div className={`${classes.caseRoot} case`} >
            <div className="card">
                <img className="quote" src={quote} alt="golden-quote-icon" />
                <Typography className={clsx("thoughts", isEnglish && "en")} variant="h4">{intl.formatMessage({ id: `empowerList.caseData.case${data.id}.thoughts` })}</Typography>
                <div className="card-bottom">
                    <div className="people">
                        <picture>
                            <source srcSet={data.avatar} type="image/webp" />
                            <img className="avatar" src={data.avatarPNG} alt={intl.formatMessage({ id: `empowerList.caseData.case${data.id}.name` })} />
                        </picture>
                        <div className="info">
                            <Typography className="job" variant="h6">{intl.formatMessage({ id: `empowerList.caseData.case${data.id}.job` })}</Typography>
                            <Typography className="name" variant="h6">{intl.formatMessage({ id: `empowerList.caseData.case${data.id}.name` })}</Typography>
                        </div>
                    </div>
                    <picture>
                        <source srcSet={data.logo} type="image/webp" />
                        <img className="logo" src={data.logoPNG} alt={intl.formatMessage({ id: `empowerList.caseData.case${data.id}.logoAlt` })} />
                    </picture>
                </div>
                <Link to={`${data.link}`}>
                    <Typography className="more-details" variant="h6" >{intl.formatMessage({ id: "system.moreDetail" })}
                        <img className="more-details-icon" src={MoreRight} alt="" />
                    </Typography>
                </Link>
            </div>
        </div >
    )
}
export default injectIntl(Banner);